import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import {nj, sway, workhuman} from '../constants/work';


const whCard = (
  <React.Fragment>
    <CardContent>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {workhuman.location}
      </Typography>
      <Typography variant="h5" component="div">
        {workhuman.title}
      </Typography>
      <Typography sx={{ mb: 1.5 }} color="text.secondary">
        {workhuman.role}
      </Typography>
      <Typography variant="body">
        {workhuman.description} 
      </Typography>
    </CardContent>
  </React.Fragment>

  )
const swayCard = (
  <React.Fragment>
    <CardContent>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {sway.location}
      </Typography>
      <Typography variant="h5" component="div">
        {sway.title}
      </Typography>
      <Typography sx={{ mb: 1.5 }} color="text.secondary">
        {sway.role}
      </Typography>
      <Typography variant="body">
        {sway.description} 
      </Typography>
    </CardContent>
  </React.Fragment>
);

const njCard = (
  <React.Fragment>
    <CardContent>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {nj.location}
      </Typography>
      <Typography variant="h5" component="div">
        {nj.title}
      </Typography>
      <Typography sx={{ mb: 1.5 }} color="text.secondary">
        {nj.role}
      </Typography>
      <Typography variant="body">
        {nj.description} 
      </Typography>
    </CardContent>
  </React.Fragment>
);

export default function Work() {
  return (
    <Box >
      <Card variant="outlined">{whCard}</Card>
      <Box sx={{ mb: 1 }} />
      <Card variant="outlined">{swayCard}</Card>
      <Box sx={{ mb: 1 }} />
      <Card variant="outlined">{njCard}</Card>
    </Box>
  );
}